import React from "react";
import { RefundStyleChartCard } from "./RefundChartCard";
import { mergeReservedModel } from "./dashboardChartsModel";

/**
 * Reserved — same chart + table + kebab as Refund (row 6, right).
 *
 * @param {object} props
 * @param {import("./dashboardChartsModel.js").CustomOrderChartModel | undefined} [props.model]
 * @param {() => void} [props.onMenuRemove]
 */
function ReservedChartCard({ model, onMenuRemove }) {
  return (
    <RefundStyleChartCard
      model={model}
      onMenuRemove={onMenuRemove}
      mergeModel={mergeReservedModel}
      titleKey="graphReserve"
      defaultTitle="Reserved"
      downloadPrefix="reserved"
      rowIdPrefix="rsv"
      cardBem="reserved"
    />
  );
}

export default ReservedChartCard;
